// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"194":"component---src-templates-post-tsx","223":"commons","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"98":"cd92e62045efbbf85a98","194":"7bd0a453dd4bc6dd0a08","223":"1565ba4c0e506056b91c","245":"ece29d0aeeb2b4595bc0","360":"f3dbf2f801e0875c7d1e"}[chunkId] + ".js";
};